import { createStorage } from "..";

const organizationStorage = createStorage({
  prefix: "organization",
  type: "local",
});

export { organizationStorage };
